package fr.manyverse.app.domain.model

const val UNIVERSAL_UNIVERSE_ID = "universal"

/** Neutral fallback theme id used for custom universes and any unresolved universe. */
const val DEFAULT_THEME_ID = "default"

enum class GameModule { ANNOUNCEMENT, WHITEBOARD, TIMER, DIGICODE, LOCKPICKING, GM_TIMER, COMBAT }

data class Universe(
    val id: String,
    val displayName: String,
    val config: UniverseConfig
)

/**
 * Returns the effective config for a table: snapshot if set, else a neutral fallback.
 */
fun resolveUniverseConfig(snapshot: UniverseConfig): UniverseConfig {
    if (!snapshot.isEmpty) return snapshot
    return UniverseConfig(
        version = UniverseConfig.CURRENT_VERSION,
        themeId = DEFAULT_THEME_ID
    )
}
